import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { FileListComponent } from './file-list/file-list.component';

import { TranslocoDirective } from '@jsverse/transloco';
import { BreadCrumbService } from '../../../@vex/components/breadcrumbs/BreadCrumbService';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { Icons } from '../../util/Icons';
import { SessionService } from '../../services/session.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { BreadcrumbsComponent } from '../../../@vex/components/breadcrumbs/breadcrumbs.component';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { PageLayoutContentDirective } from '../../../@vex/components/page-layout/page-layout-content.directive';

@Component({
	selector: 'vex-document-transfer',
	imports: [
		FileListComponent,
		BreadcrumbsComponent,
		PageLayoutComponent,
		PageLayoutHeaderDirective,
		PageLayoutContentDirective,
		TranslocoDirective,
		FileUploadComponent,
		AsyncPipe,
	],
	templateUrl: './document-transfer.component.html',
	styleUrl: './document-transfer.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [stagger40ms],
})
export class DocumentTransferComponent implements OnInit {
	protected breadCrumbService = inject(BreadCrumbService);
	private sessionService = inject(SessionService);
	private icons = inject(Icons);
	private route = inject(ActivatedRoute);

	uploadType$: Observable<string>;

	constructor() {
		this.uploadType$ = this.route.data.pipe(map((data) => data['uploadType'] || 'transfer'));
	}

	ngOnInit() {
		this.setBreadCrumbs();
	}

	private setBreadCrumbs() {
		this.breadCrumbService.reset();
		this.breadCrumbService.addBreadCrumb({
			translationKey: 'documentTransfer.title',
			icon: this.icons.get('syncAlt'),
		});
	}
}
